export default __webpack_public_path__ + "icon_snow.126452754e733ce7c9a6683213bd368f.svg";